// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"4006a02a","276":"ec3d9073","646":"d4d11e6f","877":"088def39","961":"02a2fb95"}[chunkId] + ".chunk.js";
};